import posthog from 'posthog-js';

// Session recording is off by default (see index.tsx) and only turned on for critical flows
// (order/payment, extending a proxy) via the helpers below. Several of these flows can be active
// at once (e.g. a top-up modal opened from inside the order flow), so a reference count is kept
// per "reason" and recording only stops once none of them are active anymore.
const activeFlows = new Set<string>();

export function startCriticalFlowRecording(flow: string) {
  activeFlows.add(flow);
  posthog.startSessionRecording(true);
}

export function stopCriticalFlowRecording(flow: string) {
  activeFlows.delete(flow);

  if (activeFlows.size === 0) {
    posthog.stopSessionRecording();
  }
}
